import MyDropzone from "./MyDropzone";
import React, { useEffect, useRef, useState } from "react";
import Icon from "../icons";
import { useUserInfo } from "../../context/user";
import "./style.css";
import OneDrive from "../../assets/Images/OneDrive.png";
import googleDrive from "../../assets/Images/googleDrive.png";
import dropBox from "../../assets/Images/dropBox.png";
import DropboxChooser from "../ThirdPartyServices/DropboxChooser";
import axios from "axios";
import env from "../../config/env";
import SelectAssistant from "./SelectAssistant";
import GoogleDrivePickers from "../ThirdPartyServices/GoogleDrivePickers";
import OneDrivePicker from "../ThirdPartyServices/OneDrivePicker";
import toast from "react-hot-toast";


const FilesReadyToast = ({ t, message }) => (
  <div
    style={{
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      backgroundColor: "#E7FFE9",
      border: "1px solid #009951",
      borderRadius: "12px",
      padding: "16px 18px",
      boxShadow: "0 8px 20px rgba(0, 0, 0, 0.12)",
      minWidth: "320px",
      maxWidth: "440px",
      fontFamily: "Inter, sans-serif",
      opacity: t.visible ? 1 : 0,
      transition: "opacity 0.2s ease",
    }}
  >
    <div style={{ marginTop: "2px" }}>
      <Icon id="success_tick" />
    </div>
    <div style={{ flex: 1, minWidth: 0 }}>
      <p style={{ margin: 0, fontSize: "15px", fontWeight: 600, color: "#111111" }}>
        Files Ready
      </p>
      <p style={{ margin: "4px 0 0", fontSize: "14px", color: "#1a1a1a", lineHeight: 1.4 }}>
        {message}
      </p>
    </div>
    <button
      type="button"
      onClick={() => toast.dismiss(t.id)}
      style={{ background: "none", border: "none", cursor: "pointer", padding: 0, lineHeight: 0 }}
    >
      <Icon id="close" />
    </button>
  </div>
);

function Index({ classname, refreshchat, compType = "knowledge_base", isSharedKnowledge = false }) {
  const BASE_URL = env.API_URL + "/v1";
  const [alertModel, setAlertModel] = useState(false);
  const [successModel, setSuccessModel] = useState(false);
  const [modelContent, setModelContent] = useState("");
  const userInfo = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const user = useUserInfo()[0];
  const checkIfGhlUser = useUserInfo()[9];
  const contextuploadFilefrominput = useUserInfo()[16];
  const contextUploadFilesAsync = useUserInfo()[21];
  const [toggleOption, setToggleOption] = useState(false);
  const [openAssistantModal, setOpenAssistantModal] = useState(false);
  const [openMediaAssistantModal, setOpenMediaAssistantModal] = useState(false);
  const [selectionData, setSelectionData] = useState([]);
  const [thirdPartFiles, setThirdPartyFiles] = useState([]);
  const [thirdPartyInitialFiles, setThirdPartyInitialFiles] = useState(null);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [mediaLibraryModel, setMediaLibraryModel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [mediaLibraryData, setMediaLibraryData] = useState([]);
  const [convertedFiles, setConvertedFiles] = useState([]);
  const [tempSelectedFiles, setTempSelectedFiles] = useState([]);
  const [searchMediaTerm, setSearchMediaTerm] = useState("");
  const [optionSelect, setOptionSelect] = useState("");
  const [crahsfileMessage, setcrahsfileMessage] = useState([]);
  const [uploadSummary, setUploadSummary] = useState({ docs: 0, agents: 0 });
  const [uploadProgress, setUploadProgress] = useState(null);
  const [uploadDone, setUploadDone] = useState(null);

  const alertModelRef = useRef(false);
  const eventSourceRef = useRef(null);


  const agentCount = (assistant) =>
    Array.isArray(assistant) ? assistant.length : assistant ? 1 : 0;

  const filesReadyMessage = (docs, agents, failed) => {
    if (failed > 0) {
      const ok = docs - failed;
      return `${ok} document${ok === 1 ? "" : "s"} added. ${failed} file${failed === 1 ? "" : "s"} could not be processed.`;
    }
    return isSharedKnowledge
      ? `${docs} file${docs === 1 ? "" : "s"} ${docs === 1 ? "is" : "are"} now available in the shared knowledge base.`
      : `${docs} file${docs === 1 ? "" : "s"} ${docs === 1 ? "is" : "are"} now available to ${agents} Agent${agents === 1 ? "" : "s"}.`;
  };

  useEffect(() => {
    alertModelRef.current = alertModel;
  }, [alertModel]);


  const closeUploadModal = () => {
    setAlertModel(false);
    setUploadDone(null);
    setUploadProgress(null);
    setThirdPartyInitialFiles(null);
  };

  useEffect(() => {
    return () => eventSourceRef.current?.close();
  }, []);



  const streamUploadProgress = async (jobs = []) => {
    const results = [];

    for (const job of jobs) {
      const result = await new Promise((resolve) => {
        const userId = user?._id || "";

        const source = new EventSource(
          `${BASE_URL}/chat/assistants/files/upload-progress?jobId=${job.jobId}&userId=${encodeURIComponent(userId)}&isStreaming=true`
        );

        const crashfiles = [];

        source.addEventListener("file-done", (e) => {
          const data = JSON.parse(e.data);
          if (data.status === "done") {
            toast.success(`${data.fileName} uploaded successfully . Indexing in progress…

              `);
            refreshchat();
          } else if (data.status === "failed") {
            toast.error(`${data.fileName} upload failed`);
            crashfiles.push(data.fileName);
          }
        });

        source.addEventListener("done", (e) => {
          source.close();
          const data = JSON.parse(e.data);
          resolve({
            jobId: job.jobId,
            fileName: job.fileName,
            success: data.status === "completed",
            crashfiles: data.crashfiles || crashfiles,
          });
        });

        source.addEventListener("error", () => {
          source.close();
          resolve({
            jobId: job.jobId,
            fileName: job.fileName,
            success: false,
            crashfiles,
          });
        });
      });

      results.push(result);
    }

    return results;
  };

  const filteredMediaLibraryData = mediaLibraryData?.filter((item) =>
    item.name.toLowerCase().includes(searchMediaTerm.toLowerCase()),
  );

  const handleMediaAssistantOpen = () => {
    setMediaLibraryModel(false);
    setOpenMediaAssistantModal(true);
    setOptionSelect("mediaLibrary");
  };

  const handleCloseModal = () => {
    setMediaLibraryModel(false); // Close the modal
    setSearchMediaTerm(""); // Clear the search term
  };

  const handleAction = () => {
    setDisabled(true);
    setTimeout(() => setDisabled(false), 3000); // Disable for 3 seconds
  };

  const getSelection = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/assistant/fetchbyuser?user_id=${userInfo._id}&location_id=${userActiveLocation?.id}`,
      );
      if (response) {
        let updatedResponse = [...response.data.data];
        let filteredResponse = updatedResponse.filter((item) => item.status);
        setSelectionData(filteredResponse);
      }
    } catch (error) {
      const initalAssistant = {
        assistant_name: "Brand AI",
        modal_name: "openai/gpt-4o",
        assistant_id: userActiveLocation?.assistant_id,
        status: true,
      };
      let updatedResponse = [initalAssistant];
      let filteredResponse = updatedResponse.filter((item) => item.status);
      setSelectionData(filteredResponse);
      return error;
    }
  };

  const getMediaFiles = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/assistant/files/media-library?altId=${userActiveLocation.id}&altType=location&objectId=${userActiveLocation?.id}&whichObject=account`,
      );
      if (response) {
        const files = response?.data?.data?.files;

        // Set the media library data
        setMediaLibraryData(files);

        // Process and convert files
        const downloadedFiles = await downloadFiles(
          files?.map((file) => ({
            url: file.url,
            name: file.name,
            mimeType: file.contentType, // Assuming contentType corresponds to mimeType
          })),
        );

        // Store converted files in state
        setConvertedFiles(downloadedFiles);
      }
    } catch (error) {
      console.error("Error fetching media files:", error);
    }
  };

  // Helper function to download and convert files
  const downloadFiles = async (files) => {
    return Promise.all(
      files?.map(async (file) => {
        try {
          const response = await fetch(file.url);
          const blob = await response.blob();
          return new File([blob], file.name, { type: file.mimeType });
        } catch (error) {
          console.error("Error downloading file:", error);
          return null;
        }
      }),
    ).then((results) => results.filter(Boolean));
  };

  useEffect(() => {
    getMediaFiles();
    getSelection();
  }, []);

  const handleFileSelect = (file) => {
    setTempSelectedFiles((prev) => {
      const isAlreadySelected = prev.some(
        (selectedFile) => selectedFile.id === file.id,
      );
      if (isAlreadySelected) {
        // Remove the file if already selected
        return prev.filter((selectedFile) => selectedFile.id !== file.id);
      }
      // Add the file if not selected
      return [...prev, file];
    });
  };

  const handleDoneClick = async (assistant, setLoader) => {
    var response = await contextuploadFilefrominput(
      convertedFiles,
      userActiveLocation?.id,
      user?.userName,
      assistant,
      compType,
    );
    if (response.data.data[0].success) {
      setUploadSummary({ docs: convertedFiles?.length || 0, agents: agentCount(assistant) });
      setMediaLibraryModel(false);
      setTempSelectedFiles([]);
      setModelContent("file Submitted ..!");
      setOpenAssistantModal(false);
      setAlertModel(false);
      setOpenMediaAssistantModal(false);
      setSuccessModel(true);
      setLoader(false);
      refreshchat();
    }
    if (response?.data?.crashfiles?.length > 0) {
      setcrahsfileMessage(response?.data?.crashfiles);
      setModelContent("file Submitted ..!");
      setAlertModel(false);
      setSuccessModel(true);
    }
  };

  const isUploadSuccess = (response) =>
    isSharedKnowledge
      ? response?.data?.success
      : response?.data?.data?.[0]?.success;

  const saveDropzoneFiles = async (files, assistant) => {
    const docs = files?.length || 0;
    const agents = agentCount(assistant);


    

    // All Knowledge Base uploads — Agent Knowledge, Data Interpreter and Shared
    // Knowledge — go through the streaming/async path so the UI shows per-file
    // progress + toasts and an in-modal "Files Ready" summary. compType is
    // forwarded and, together with the selected agents, tells the backend which
    // store to route to (assistant / code-interpreter / profile-shared).
    setcrahsfileMessage([]);

    try {
      const start = await contextUploadFilesAsync(
        files,
        userActiveLocation?.id,
        user?.userName,
        assistant,
        user?._id,
        compType,
      );

      if (!start?.success || !start?.jobs?.length) {
        setAlertModel(false);
        toast.error("Could not start the upload. Please try again.");
        return;
      }

      const results = await streamUploadProgress(start.jobs);
      const allCrashfiles = results.flatMap((r) => r.crashfiles || []);

      setcrahsfileMessage(allCrashfiles);
      setUploadSummary({ docs, agents });
      refreshchat();

      const failed = allCrashfiles.length;

      // Always stop the loader — set uploadDone regardless of modal state
      setUploadDone({
        docs,
        agents,
        status: failed === docs ? "failed" : "completed",
        crashfiles: allCrashfiles,
      });

      if (!alertModelRef.current) {
        toast.custom(
          (t) => <FilesReadyToast t={t} message={filesReadyMessage(docs, agents, failed)} />,
        );
      }
    } catch (err) {
      setAlertModel(false);
      toast.error("Upload failed. Please try again.");
    }
  };

  console.log("saveDropzoneFiles", saveDropzoneFiles)

  const saveThirdPartyFiles = async (assistant, setLoader, filesOverride) => {
    var response = await contextuploadFilefrominput(
      filesOverride || thirdPartFiles,
      userActiveLocation?.id,
      user?.userName,
      assistant,
      compType,
    );
    setToggleOption(false);
    if (isUploadSuccess(response)) {
      setModelContent("file Submitted ..!");
      setOpenAssistantModal(false);
      setSuccessModel(true);
      setLoader?.(false);
      refreshchat();
    }
    if (response?.data?.crashfiles?.length > 0) {
      setcrahsfileMessage(response?.data?.crashfiles);
      setModelContent("file Submitted ..!");
      setAlertModel(false);
      setSuccessModel(true);
    }
  };

  const isImageFile = (file) => {
    const mime = (file?.type || file?.mimeType || "").toLowerCase();
    if (mime.startsWith("image/")) return true;
    const name = (file?.name || "").toLowerCase();
    return /\.(jpe?g|png|gif|webp|bmp|svg|tiff?|heic|heif|ico)$/i.test(name);
  };

  const files_recieved_from_child = async (files, type) => {
    const incoming = Array.isArray(files) ? files : [];
    const filtered = incoming.filter((f) => !isImageFile(f));
    const removedCount = incoming.length - filtered.length;
    if (removedCount > 0) {
      alert("Image files are not allowed and have been skipped.");
    }
    if (filtered.length === 0) return;

    setThirdPartyFiles(filtered);
    // Route Google Drive / Dropbox files through the same MyDropzone modal used
    // by "Upload From Computer" so third-party uploads get the identical
    // experience. MyDropzone adapts to the context: Agent Knowledge shows the
    // Assign-Agents step, Shared Knowledge skips straight to processing.
    setUploadDone(null);
    setUploadProgress(null);
    setcrahsfileMessage([]);
    setThirdPartyInitialFiles(filtered);
    setAlertModel(true);
    setToggleOption(false);
  };

  const handleRemoveThirdPartyFile = (index) => {
    setThirdPartyFiles((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      // Close the modal automatically if no files remain
      if (updated.length === 0) {
        setOpenAssistantModal(false);
      }
      return updated;
    });
  };

  return (
    <>
      {/* alerts */}
      {alertModel && (
        <>
          <div className="modal-zz" onClick={closeUploadModal}>
            <div
              className="modal-content-zz position-relative"
              onClick={(e) => e.stopPropagation()}
            >
              <MyDropzone
                saveDropzoneFiles={saveDropzoneFiles}
                selectionData={selectionData}
                isSharedKnowledge={isSharedKnowledge}
                onClose={closeUploadModal}
                uploadProgress={uploadProgress}
                uploadDone={uploadDone}
                initialFiles={thirdPartyInitialFiles}
              />
            </div>
          </div>
        </>
      )}

      {successModel && (
        <>
          <div className="modal-zz" onClick={() => setSuccessModel(false)}>
            <div
              className="modal-content-zz"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="kb-ready-head">
                <b className="kb-ready-title">Files Ready</b>
                <button
                  type="button"
                  className="kb-modal-close"
                  onClick={() => setSuccessModel(false)}
                >
                  <Icon id="close" />
                </button>
              </div>

              {crahsfileMessage.length < 1 ? (
                <p className="kb-ready-text">
                  {uploadSummary.docs} document
                  {uploadSummary.docs === 1 ? "" : "s"}{" "}
                  {uploadSummary.docs === 1 ? "has" : "have"} been added to{" "}
                  {isSharedKnowledge
                    ? "the shared knowledge base"
                    : `${uploadSummary.agents} agent${uploadSummary.agents === 1 ? "" : "s"}`}
                  .
                </p>
              ) : (
                <>
                  <p className="kb-ready-text" style={{ color: "#ec221f" }}>
                    The listed files failed to upload. Maybe the token limit was
                    exceeded.
                  </p>
                  <ul className="kb-ready-failed">
                    {crahsfileMessage.map((item, index) => (
                      <li key={index}>
                        {item.length > 30 ? `${item.slice(0, 30)}...` : item}
                      </li>
                    ))}
                  </ul>
                </>
              )}

              <div className="kb-footer kb-footer--start">
                <button
                  type="button"
                  className="kb-done-btn"
                  onClick={() => setSuccessModel(false)}
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      <div
        className="upload_box shadow"
        style={{ position: "relative" }}
      >
        <div className="flex gap-2 px-4 items-center " onClick={() => {
          setToggleOption(!toggleOption);
          handleAction();
        }}>
          <Icon id="KBUpload" />
          Upload
        </div>

        {toggleOption && (
          <div className="v3_dropdown">
            {/* <span onClick={() => {
              setMediaLibraryModel(!mediaLibraryModel);
            }}
            >
              <div style={{ paddingRight: "7px" }}>
                <Icon id="upload" />
              </div>
              GHL Media Library
            </span> */}

            <span>
              <img
                src={googleDrive}
                alt="googleDrive"
                style={{ marginRight: "7px" }}
              />
              <GoogleDrivePickers
                disabled={disabled}
                files_send_to_parent={files_recieved_from_child}
                setSpinnerLoading={setSpinnerLoading}
              />
            </span>

            <span>
              <img
                src={dropBox}
                alt="Drop Box"
                style={{ marginRight: "7px" }}
              />
              <DropboxChooser
                disabled={disabled}
                files_send_to_parent={files_recieved_from_child}
                setSpinnerLoading={setSpinnerLoading}
              />
            </span>

            {/* <span>
              <img
                src={OneDrive}
                alt="One Drive"
                style={{ marginRight: "7px" }}
              />
              <OneDrivePicker
                files_send_to_parent={files_recieved_from_child}
              />
            </span> */}

            <span
              onClick={() => {
                // Clear any leftover state from a previous upload so the modal
                // always opens on the fresh "Upload files" screen instead of a
                // stale "Files Ready" summary.
                setUploadDone(null);
                setUploadProgress(null);
                setcrahsfileMessage([]);
                setThirdPartyInitialFiles(null);
                setAlertModel(true);
                setToggleOption(!toggleOption);
              }}
              style={{
                borderBottom: "1px solid #E5E5E5",
                borderTop: "1px solid #E5E5E5",
              }}
              className="text-[14px]"
            >
              <div style={{ paddingRight: "7px" }}>
                <Icon id="upload" />
              </div>
              Upload From Computer
            </span>
          </div>
        )}
      </div>

      {openAssistantModal && (
        <>
          <div className="modal-zz">
            <div
              className="modal-content-zz position-relative"
              onClick={(e) => e.stopPropagation()}
            >
              <p
                style={{
                  position: "absolute",
                  right: 5,
                  width: "12px",
                  top: "10px",
                  height: "12px",
                  cursor: "pointer",
                }}
                onClick={() => setOpenAssistantModal(false)}
              >
                X
              </p>

              <SelectAssistant
                optionSelect={optionSelect}
                saveThirdPartyFiles={saveThirdPartyFiles}
                handleDoneClick={handleDoneClick}
                selectionData={selectionData}
                files={thirdPartFiles}
                onRemoveFile={handleRemoveThirdPartyFile}
                onClose={() => setOpenAssistantModal(false)}
              />
            </div>
          </div>
        </>
      )}

      {openMediaAssistantModal && (
        <>
          <div className="modal-zz">
            <div
              className="modal-content-zz position-relative"
              onClick={(e) => e.stopPropagation()}
            >
              <p
                style={{
                  position: "absolute",
                  right: 5,
                  width: "12px",
                  top: "10px",
                  height: "12px",
                  cursor: "pointer",
                }}
                onClick={() => setOpenMediaAssistantModal(false)}
              >
                X
              </p>

              <SelectAssistant
                optionSelect={optionSelect}
                saveThirdPartyFiles={saveThirdPartyFiles}
                handleDoneClick={handleDoneClick}
                selectionData={selectionData}
                onClose={() => setOpenMediaAssistantModal(false)}
              />
            </div>
          </div>
        </>
      )}

      {mediaLibraryModel && (
        <div className="select_file_modal" onClick={handleCloseModal}>
          <div
            className="select_file_modal_content"
            onClick={(e) => e.stopPropagation()}
          >
            <p
              style={{
                position: "absolute",
                right: 10,
                width: "12px",
                top: "10px",
                height: "12px",
                cursor: "pointer",
              }}
              onClick={handleCloseModal}
            >
              X
            </p>

            <div
              style={{
                marginBottom: "34px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <b className="text_black">Select a file</b>

              <input
                type="search"
                placeholder="Search"
                style={{
                  outline: "1px solid black",
                  borderRadius: "5px",
                  width: "50%",
                  padding: "10px",
                }}
                value={searchMediaTerm}
                onChange={(e) => setSearchMediaTerm(e.target.value)}
              />
            </div>

            <div style={{ maxHeight: "350px", overflow: "auto" }}>
              <div className="v3_modal_table_heading">
                <p>File Name</p>
                <p style={{ textAlign: "center" }}>Date created</p>
                <p></p>
              </div>

              <div>
                {filteredMediaLibraryData?.length > 0 ? (
                  filteredMediaLibraryData?.map((item, index) => (
                    <div className="v3_modal_table_body" key={index}>
                      <p>
                        {item.name.length > 15
                          ? item.name.slice(0, 15) + "..."
                          : item.name}
                      </p>
                      <p style={{ textAlign: "center" }}>
                        {new Date(item.createdAt).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </p>
                      <div className="v3_modal_table_body_input">
                        <input
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          onChange={() => handleFileSelect(item)}
                          checked={tempSelectedFiles.some(
                            (selectedFile) => selectedFile.id === item.id,
                          )}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <p style={{ alignItems: "center", display: "flex" }}>
                    No files found
                  </p>
                )}
              </div>
            </div>

            <button
              className="v3_modal_table_button"
              onClick={handleMediaAssistantOpen}
            >
              Done
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Index;
